import React, { useMemo } from 'react';

import { Route, useParams, useRouteMatch } from 'react-router-dom';

import { useSidePage } from 'components/Modal';
import useIsMounted from 'hooks/useIsMounted';

import { IRouteComponent, ISidePageRoute } from './interfaces';
import useLegacyHistory from './useLegacyHistory';

const RouteComponent = ({
  modal: Modal,
  idKey,
  parentPath,
}: IRouteComponent) => {
  const params: any = useParams();
  const isMounted = useIsMounted();
  const routeMatch = useRouteMatch();

  const paramsId = useMemo(() => {
    return Number(params[idKey]) || params[idKey];
  }, [params[idKey]]);

  const routeMatchUrl = routeMatch.url;

  const { id, onExited } = useLegacyHistory({
    paramsId,
    routeMatchUrl,
    parentPath,
  });

  const [present, dismiss] = useSidePage(Modal);

  const handlePresent = () => {
    present({
      id: paramsId,
      parentPath: routeMatchUrl,
      onExited: onExited,
    });
  };

  React.useEffect(() => {
    if (id && isMounted) {
      handlePresent();
    }
    return () => {
      dismiss();
    };
  }, [id]);

  return null;
};

export const SidePageRoute = ({
  modal,
  prefix = '/',
  idKey = 'id',
}: ISidePageRoute) => {
  const routeMatch = useRouteMatch();
  const path = `${routeMatch.path}${prefix}:${idKey}`;
  const parentPath = `${routeMatch.path}`;
  return (
    <Route path={path}>
      <RouteComponent modal={modal} idKey={idKey} parentPath={parentPath} />
    </Route>
  );
};
